'use client';

/* eslint-disable @next/next/no-img-element */

import { faClock, faUtensils } from '@fortawesome/pro-regular-svg-icons';
import { CSSProperties, FC } from 'react';
import RecipeShoppingCart from '@/components/recipes/recipe-shopping-cart/recipe-shopping-cart';
import { Icon } from '@/components/ui/icon/icon';
import { RECIPE_HERO_LCP_IMAGE_SIZES } from '@/utils/recipe-hero-lcp';

export interface RecipeHeroProps {
  image: string;
  imageSrcSet?: string;
  imageSizes?: string;
  title: string;
  cookingTime?: string;
  servings?: string;
  cartProductIds?: string[];
  titleColor?: string;
  cookingTimeColor?: string;
  servingsColor?: string;
  ingredientsColor?: string;
  paddingStyle?: CSSProperties;
}

const RecipeHeroBanner: FC<RecipeHeroProps> = ({
  image,
  imageSrcSet,
  imageSizes = RECIPE_HERO_LCP_IMAGE_SIZES,
  title,
  cookingTime,
  servings,
  cartProductIds,
  titleColor,
  cookingTimeColor,
  servingsColor,
  ingredientsColor,
  paddingStyle,
}) => {
  const hasCart = cartProductIds && cartProductIds.length > 0;

  return (
    <div className="container mx-auto" style={paddingStyle}>
      <div className={`grid gap-6 ${hasCart ? '@4xl:grid-cols-[1fr_460px]' : ''}`}>
        <div className="flex flex-col gap-4">
          <div className="relative aspect-[16/10] max-h-[520px] w-full overflow-hidden rounded-2xl">
            <img
              src={image}
              srcSet={imageSrcSet}
              sizes={imageSizes}
              alt={title}
              width={1280}
              height={800}
              fetchPriority="high"
              loading="eager"
              decoding="async"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
          <div>
            <h1
              className="mb-3 text-xl leading-tight font-bold @md:text-2xl @lg:text-3xl"
              style={titleColor ? { color: titleColor } : undefined}
            >
              {title}
            </h1>
            <div className="flex flex-wrap items-center gap-2">
              {cookingTime && (
                <span
                  className="flex items-center gap-1 rounded-full bg-green-600 px-2.5 py-1 text-xs font-medium text-white @md:gap-1.5 @md:px-3 @md:py-1.5 @md:text-sm"
                  style={cookingTimeColor ? { color: cookingTimeColor } : undefined}
                >
                  <Icon icon={faClock} className="text-xs" />
                  {cookingTime}
                </span>
              )}
              {servings && (
                <span
                  className="flex items-center gap-1 rounded-full bg-orange-600 px-2.5 py-1 text-xs font-medium text-white @md:gap-1.5 @md:px-3 @md:py-1.5 @md:text-sm"
                  style={servingsColor ? { color: servingsColor } : undefined}
                >
                  <Icon icon={faUtensils} className="text-xs" />
                  {servings}
                </span>
              )}
            </div>
          </div>
        </div>

        {hasCart && (
          <div className="@lg:pt-0">
            <RecipeShoppingCart productIds={cartProductIds!} ingredientsColor={ingredientsColor} />
          </div>
        )}
      </div>
    </div>
  );
};

export default RecipeHeroBanner;
